import angular from 'angular';
import breadCrumb from './breadCrumb';
import './style.scss';

export default angular
  .module('components.breadCrumb', [])
  .component('breadCrumb', breadCrumb).name;
